export default "__VITE_ASSET__D6L1AwBp__"